import "./utility/firebase";
import { useState, useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Classes from "./pages/home/draftOrdersNew/css/draftOrderDetailPage.module.css";
import axios from "./utility/axios-instance";
import Alert from "react-bootstrap/Alert";
import Dropdown from 'react-bootstrap/Dropdown';
import resetState from "./store/actions";
import { setShow } from "./store/toggleNavSlice";
import LocationOnIcon from '@mui/icons-material/LocationOn';

import "./index.scss";
import Auth from "./pages/auth/auth";
import SignIn from "./pages/auth/signIn";
import Profile from "./pages/auth/profile";
import Home from "./pages/home/home";
import CreateNewUser from "./pages/home/users/new";
import UserId from "./pages/home/users/userId";
import Cancels from "./pages/home/cancels/cancels";
import NotFound from "./pages/not-found";
import DeliveryBoyOrders from "./pages/home/deliveryBoy/deliveryBoyOrders";
import DeliveryBoyOrderId from "./pages/home/deliveryBoy/deliveryBoyOrderId";
import CreateOrder from "./pages/home/createOrders/createOrder";
import CustomerProfile from "./pages/home/customers/customerProfile";
import UpdatePricingProducts from "./pages/home/updatePricing/updatePricingProducts";
import Products from "./pages/home/product/products";
import FranchiseInventoryManagement from "./pages/home/franchiseDashboards/inventoryManagement";
import FranchiseProductManagement from "./pages/home/franchiseDashboards/productManagement";
import AddProduct from "./pages/home/product/addProducts/addProduct";
import ProductsCreated from "./pages/home/productCreated/productCreated";
import ProductDetails from "./pages/home/product/ProductDetailPage/ProductDetails";
import ProductsCreatedDetails from "./pages/home/productCreated/groupProductCreated";
import UploadImages from "./pages/home/uploadImages/uploadImages";
import UploadImagesNew from "./pages/home/uploadImages/uploadImagesNew";
import UploadOthersMaster from "./pages/home/uploadOthersMaster/uploadOthersMaster";
import { Blog } from "./pages/home/blog/blog";
import CreateBlog from "./pages/home/blog/createBlog";
import BlogDetail from "./pages/home/blog/blogDetailPage";
import SkuToQrCode from "./pages/home/skuToQrCode/skuToQrCode";
import CreatePurchaseOrder from "./pages/home/createPurchaseOrder/createPurchaseOrder";
import DraftPurchaseOrders from "./pages/home/draftPurchaseOrder/draftPurchaseOrders";
import DraftPurchaseOrderDetail from "./pages/home/draftPurchaseOrder/draftPurchaseOrderDetail";
import OrdersNew from "./pages/home/ordersNew/orders";
import DocsListDashboard from "./pages/home/docsList/docsList.js";
import OrderDetail from "./pages/home/ordersNew/orderDetailPage";
import InboundPurchaseOrders from "./pages/home/inboundPurchaseOrders/inboundPurchaseOrders";
import InboundPurchaseOrderDetail from "./pages/home/inboundPurchaseOrders/inboundPurchaseOrderDetailPage";
import PurchaseOrders from "./pages/home/purchaseOrders/purchaseOrders";
import PurchaseOrderDetail from "./pages/home/purchaseOrders/purchaseOrderDetailPage";
import InventoryMove from "./pages/home/inventoryMove/InventoryMove";
import InventoryView from "./pages/home/inventoryView/InventoryView";
import InventoryAdjustments from "./pages/home/inventoryAdjustments/inventoryAdjustments";
import RefundsNew from "./pages/home/refundsNew/refunds";
import ReturnsNew from "./pages/home/returnsNew/returns";
import CancelsNew from "./pages/home/cancelsNew/cancels";
import ReturnDetail from "./pages/home/returnsNew/returnDetailPage";
import UsersNew from "./pages/home/usersNew/users";
import Bins from "./pages/home/bins/bins";
import Roles from "./pages/home/users/roles";
import Affiliate from "./pages/home/affiliateDashboard/affiliate";
import FieldSales from "./pages/home/fieldSalesDashboard/fieldSales";
import MyCustomers from "./pages/home/myCustomerDashboard/myCustomers";
import CustomerDetails from "./pages/home/myCustomerDashboard/customerDetails";
import ManagerDashboard from "./pages/home/managerDashboard/manager";
import Customers from "./pages/home/customers/customersNew";
import ProductTransactions from "./pages/home/product/ProductTransactions";

import { Logout } from "@mui/icons-material";
import NotificationsIcon from '@mui/icons-material/NotificationsNone';
import Dispatch from "./pages/home/dispatch/dispatch";
import DraftOrdersNew from "./pages/home/draftOrdersNew/draftOrders";
import DraftOrderDetailPageNew from "./pages/home/draftOrdersNew/draftOrderDetailPage";
import DeliveryRiders from "./pages/home/deliveryRider/deliveryRiders";
import SchemeDashboard from "./pages/home/scheme/dashboard";
import Schemes from "./pages/home/scheme/setUpScheme/schemes";
import Estimates from "./pages/home/estimate/estimates";
import EstimateId from "./pages/home/estimate/estimateId";
import SkuTransactions from "./pages/home/skuTransactions/skuTransactions";
import OrderAllocation from "./pages/home/ordersNew/orderAllocations";
import OrderAllocated from "./pages/home/orderAllocation/orderAllocations";
import Commission from "./pages/home/affiliateDashboard/commission";
import CreateCommission from "./pages/home/affiliateDashboard/createCommission";
import UpdateCommission from "./pages/home/affiliateDashboard/updateCommission";
import Locations from "./pages/home/locations/location";
import DeliveryShipping from "./pages/home/deliveryShipping/deliveryShipping";
import ReturnInwards from "./pages/home/inwardReturns/inwardReturns";
import PoInwards from "./pages/home/inwardPurchaseOrder/inwardPo";
import Commissions2 from "./pages/home/commissions2/Commissions2";
import MaintenancePage from "./pages/maintenance";
import CustomerUpdateHistory from "./pages/home/customers/customerUpdateHistory";
import InterWarehouseInventoryMove from "./pages/home/interWHInventoryMove/createInterWHInventoryMoves";
import { Chip, Tooltip ,Box } from "@mui/material";
import DynamicBanners from "./pages/home/dynamicBanners/dynamicBanners";
import CreateDynamicBanner from "./pages/home/dynamicBanners/createDynamicBanner";
import DynamicBanner from "./pages/home/dynamicBanners/dynamicBanner";
import DraftInterWarehouseInventoryMoves from "./pages/home/interWHInventoryMove/draftInterWarehouseInventoryMoves";
import InterWarehouseInventoryMoves from "./pages/home/interWHInventoryMove/interWarehouseInventoryMoves";
import PaymentGatewayTransactions from "./pages/home/paymentGatewayTransactions/paymentGatewayTransactions";
import CreditAgreement from "./pages/home/customers/creditAgreement.js";
import Laminates from "./pages/home/laminates/laminates.js";
import CreateLaminate from "./pages/home/laminates/createLaminate.js";
import Laminate from "./pages/home/laminates/laminate.js";

import axiosInstance from "./utility/axios-instance";
import Franchises from "./pages/home/franchise/franchises";
import PushNotifications from "./pages/home/pushNotifications/pushNotifications";
import PinnedTab from "./pinnedTab";
import Analytics from "./pages/home/dashboard/dashboard";
import DraftInterWHInventoryMoveDetails from "./pages/home/draftInterWHInventoryMove/draftInterWHInventoryMoveDetails";

import { Bounce, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  Settings,
  Discount,
  CreateDiscount,
  CompanyHome,
  WebsiteSettings,
  Store,
  CustomerHome,
  ProductRangeSettings,
  MainBanners,
  ShowStoreLocationTable,
  ShowStoreImages,
  NotificationSettings
} from "./pages/home/settings/index.js";
import Addresses from "./pages/home/customers/addresses";
import NotificationDialog from "./pages/home/dashboard/notifications";
import Pincodes from "./pages/home/settings/pincodes";
import UserActivities from "./pages/home/userActivities/userActivities";
import UpdateProductManagement from "./pages/home/franchiseDashboards/updateProductManagement";
import socket from "./socket";
import LedgerDashboard from "./pages/home/customers/ledgerDashboard.js";
import EditPurchaseOrder from "./pages/home/editPurchaseOrder/editPurchaseOrder";
import InventoryStockOut from './pages/home/inventoryStockOut/inventoryStockOut.js';
import PrivateRoutes from "./utility/privateRoute";
import { Badge } from "@mui/material";
import MyNotification from "./pages/home/settings/Notifications/myNotification.js";
import LowInventoryTracker from "./pages/home/inventoryView/lowInventoryTracker.js";
import InventoriesWithPurchaseOrderDetails from './pages/home/inventoryView/inventoriesWithPurchaseOrderDetails.js'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import notificationSoundPath from './assets/notification-sound-uv.wav';
import InventoryAnalytics from "./pages/home/inventoryView/inventoryAnalytics.js";
import ReportAnalytics from "./pages/home/dashboard/reportAnalytics.js";
import InventoriesWithAllLocations from "./pages/home/inventoryView/inventoriesWithAllLocations.js";
import Catalogues from "./pages/home/settings/catalogues/index.js";
import CatalogueDetails from "./pages/home/settings/catalogues/catalogueDetails.js";
import DownloadedReports from "./pages/home/settings/catalogues/downloadedReports.js";
import RiderDetails from "./pages/home/deliveryRider/riderDetails.js";
import LocationWatcher from "./components/locationTracker.js";
import States from "./pages/home/settings/states";
import ReportServiceNew from "./pages/home/reportServiceNew/reportServiceNew";
import ReportItems from "./pages/home/reportServiceNew/reportItems";
const NAV_WIDTH = 240;


function App() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isCreateOrderPage, setIsCreateOrderPage] = useState(false);
  const auth = useSelector((state) => state.auth);
  const show = useSelector((state) => state.toggleNav.show);

  const [navWidth, setNavWidth] = useState(NAV_WIDTH);
  const [isNavCollapse, setIsNavCollapse] = useState(false);

  const isMaintenance = process.env.REACT_APP_MAINTENANCE === "true";
  const dispatch = useDispatch();
  const deliveryShippingTabs = ["pickList", "qc", "pack", "dispatch", "onHold", "bills", "fulfillments"];
  const inwardTabs = ["inbound", "qc", "putaway"];

  // eslint-disable-next-line no-unused-vars
  const [socketConnected, setSocketConnected] = useState(false);
  const [open, setOpen] = useState(false);
  const [notification, setNotification] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [unSeenNotificationsCount, setUnSeenNotificationsCount] = useState();
  const [page, setPages] = useState(1);
  const [maxPages, setMaxPage] = useState(1);
  const [totalActiveUsers, setTotalActiveUsers] = useState(0);

  const user = auth.user;
  const userRef = useRef(user);

  const playNotificationSound = () => {
    const audio = new Audio(notificationSoundPath);
    audio.play().catch(error => {
      console.log('Notification Playback failed:', error);
    });
  };

  useEffect(() => {
    if (process.env.REACT_APP_Socket === "true") {
      socket?.emit("setup", user);
    }

    userRef.current = user;
  }, [user]);

  useEffect(() => {
    function onConnect() {
      setSocketConnected(true);
      console.log("Socket Connected!");
    }

    function onDisconnect() {
      setSocketConnected(false);
      console.log("Socket Disconnected!");
    }

    if (process.env.REACT_APP_Socket === "true") {
      socket?.on("connect", onConnect);
      socket?.on("disconnect", onDisconnect);
    }

    return () => {
      socket?.off("connect");
      socket?.off("disconnect");
    };
  }, []);

  const logout = () => {
    setLoading(true);
    setError(null);

    axios
      .get("/admin/auth/logout")
      .then(() => {
        resetState(dispatch);
      })
      .catch((err) => {
        setError(err.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const collapseNavbar = () => {
    const collapseController = {
      true: () => setNavWidth(70),
      false: () => setNavWidth(245),
    };

    collapseController[!isNavCollapse]();

    setIsNavCollapse(!isNavCollapse);
  };

  const success = (pos) => {
    const location = {
      accuracy: pos.coords.accuracy,
      altitude: pos.coords.altitude,
      altitudeAccuracy: pos.coords.altitudeAccuracy,
      heading: pos.coords.heading,
      latitude: pos.coords.latitude,
      longitude: pos.coords.longitude,
      speed: pos.coords.speed,
      timestamp: pos.timestamp,
    };

    if (user) {
      socket?.emit("location changed", { location, user });
    }
  };

  useEffect(() => {
    if (user) {
      socket?.emit("New Notification", user);
    }
  }, [user]);

  // useEffect(() => {
  //   setInterval(() => {
  //     navigator.geolocation.getCurrentPosition((pos) => {
  //       const geoLocation = {
  //         accuracy: pos.coords.accuracy,
  //         altitude: pos.coords.altitude,
  //         altitudeAccuracy: pos.coords.altitudeAccuracy,
  //         heading: pos.coords.heading,
  //         latitude: pos.coords.latitude,
  //         longitude: pos.coords.longitude,
  //         speed: pos.coords.speed,
  //         timestamp: pos.timestamp,
  //       };

  //       sendGeoLocation({ geoLocation });
  //     });
  //   }, 60000);
  // }, []);

  // useEffect(() => {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition((pos) => {});

  //     navigator.permissions.query({ name: "geolocation" }).then((result) => {
  //       if (result.state === "granted") {
  //         navigator.geolocation.watchPosition(success);
  //       } else if (result.state === "prompt") {
  //         navigator.geolocation.getCurrentPosition((pos) => {});
  //       } else if (result.state === "denied") {
  //       }

  //       result.onchange = function () {
  //         if (result.state === "granted") {
  //           navigator.geolocation.watchPosition(success);
  //         }
  //       };
  //     });
  //   } else {
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (user) {
      socket?.on("notification Received", (user) => {
        setUnSeenNotificationsCount(
          user?.notification || 0
        );
      });
      fetchTotalActiveUsersOnPortal();
    }
  }, [user]);

  const realTimeNotify = (content) => toast(content, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    transition: Bounce,
    icon: <NotificationsIcon />,
    });

  // BATCH THE NOTIFICATIONS IF THEY ARE COMING IN BULK
  const NOTIFICATION_BATCH_TIME = 1000;
  let notificationQueue = useRef([]);
  let timeoutRef = useRef(null);

  useEffect(() => {
    
    const handleNewNotifications =  (target_value, target_type, restrictedUsers = [], content = '') => {
      console.log("Event Listening");
      const loggedInUser = userRef.current;
      let shouldNotify = false;
      if(!loggedInUser) return;

      if(target_type === 'role' && target_value.includes(loggedInUser.role) && !restrictedUsers.includes(loggedInUser?.username))
        shouldNotify = true;
      else if(target_type === 'user' && target_value.includes(loggedInUser?._id))
        shouldNotify = true;

      if(shouldNotify ) {
        notificationQueue.current.push(content);
        if(!timeoutRef.current) {
          timeoutRef.current = setTimeout(() => {

            if (notificationQueue.current.length > 5) {
              realTimeNotify(`You have received ${notificationQueue.current.length} new notifications.`);
            } else {
              notificationQueue.current?.forEach(content => realTimeNotify(content));
            }
            playNotificationSound(); // Play sound once
            socket?.emit("New Notification", user);

            // Clear queue and reset timeout
            notificationQueue.current = [];
            timeoutRef.current = null;
          }, NOTIFICATION_BATCH_TIME);
        }
      }
    };

    socket?.on("Newly Created Notification", handleNewNotifications);
    return () => {
      socket?.off("Newly Created Notification");
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
  
  useEffect(() => {
    user && user?._id && axiosInstance
    .get(
      `/adminNotifications/${user?._id}?page=${page}`
    )
    .then((res) => {
      console.log(res.data.data,"Data")
      setUnSeenNotificationsCount(res.data.data.count)
    })
    .catch(err=>{
      console.log(err,'error')
    })
  }, [user])


  const handleNotification = async () => {
    setPages(1);
    await axiosInstance
      .get(
        `/adminNotifications/${user?._id}?page=${1}`
      )
      .then((res) => {
        setNotifications(res.data.data.notifications);
        setMaxPage(res.data.data.maxPage);
        setUnSeenNotificationsCount(res.data.data.count)
        setPages(2);
      })
      .catch(err=>{
        console.log(err,'error')
      })

    setOpen(true);
  };

  const fetchMoreData = () => {
    if (maxPages >= page) {
      setTimeout(() => {
        axiosInstance
          .get(
            `/adminNotifications/${user?._id}?page=${page}`
          )
          .then((res) => {
            if (res.data.data.maxPage >= page) {
              setPages(page + 1);
            } else {
              setPages(1);
            }
            setNotifications([
              ...notifications,
              ...res.data.data.notifications,
            ]);
          });
      }, 1500);
    }
  };
  
  const fetchTotalActiveUsersOnPortal = async () => {
    user.role === 'super-admin' && 
    await axiosInstance
      .get("admin/auth/activeUsers")
      .then((res) => {
        setTotalActiveUsers(res?.data?.data?.activeUsers?.length ?? 0);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <BrowserRouter>
      {auth.authenticated ? (
        <>
          <div style={{ display: "flex" }}>
            <div id="logo">
              <img
                className={Classes.newCompanyLogo}
                src="https://cdn.shopify.com/s/files/1/0566/3182/0333/files/LOGO-color.png?v=1647674394"
                alt="logo"
                height={32}
                id="newCompanyLogo"
              />
            </div>
            <div id="officeAddressPrint" className={Classes.hideHeader}>
              <h4>Depo Solutions Private Limited</h4>
              <div style={{ fontSize: "14px" }}>
                <p>77/1/A, Christopher Road, Topsia,</p>
                <p>Kolkata, West Bengal</p>
                <p>700046</p>
                <p>GSTIN 19AAJCD1058P1Z4</p>
              </div>
            </div>
          </div>

          <header
            id="header"
            className={["bg-dark", Classes.Header].join(" ")}
            style={{
              position: "sticky",
              top: 0,
              zIndex: isNavCollapse ? 1201 : 1000,
            }}
          >

            <ToastContainer 
              style={{
                width: '27%',
              }}
            />
            
            <div
              className="d-flex"
              id="logoCenter"
              style={{  marginBottom: 10, width:'100%' }}
            >
              <div className={Classes.CompanyLogo}>
                <div id="logo">
                  {isNavCollapse && (
                    <img
                      className={Classes.logo}
                      style={{ transition: "all 0.3s ease-in-out" }}
                      src={`data:image/png;base64,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`}
                      alt="logo"
                      height={32}
                      id="companyLogo"
                    />
                  )}
                </div>
              </div>

              <div
                className="d-flex align-items-center" 
                style={{ gap: '1rem', justifyContent: 'space-between', width: '100%', padding:'0px 15px' }}
                id="removeUserPrint"
              >
                <PinnedTab isNavCollapse={isNavCollapse} />
                
                <div style={{ display:'flex', gap:'1rem', alignItems:'center' }}>
                  <div
                    className="hamburger"
                    onClick={() => {
                      dispatch(setShow({ show: !show }));
                    }}
                  >
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>

                  <Box className={Classes.mobileResponsiveLogo}>
                    <img 
                      style={{width: '88px'}} 
                      src='/assets/haus-logo.png' 
                      alt='Haus-by-Tirupati'
                    />
                  </Box>
                </div>

                <div style={{ display:'flex', gap:'1rem', alignItems:'center' }}>
                  {/* {auth?.user?.locations?.length !== 0 && (
                    <div className={Classes.LocationChipDesktop}>
                      {auth?.user?.locations?.length &&
                        auth?.user?.locations?.map((item, i) => (
                          <Chip
                            icon={<LocationOnIcon style={{ color: "fff" }} />}
                            key={i}
                            size="small"
                            label={item}
                            style={{
                              marginRight: 5,
                              backgroundColor: "#ff6200",
                              color: "#fff",
                            }}
                          />
                        ))}
                    </div>
                  )} */}

                  {auth?.user?.locations?.length !== 0 && (
                    <Dropdown>
                      <Dropdown.Toggle variant="secondary" id="dropdown-basic" style={{padding:'4px 10px', backgroundColor:'#243750', border:0 }}>
                        <LocationOnIcon style={{fontSize:"20px", marginTop:"-5px" }}/>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {auth?.user?.locations?.map((item, i) => (
                          <Dropdown.Item>{item}</Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  )}

                  {user && user?.role === 'super-admin' &&
                    <div className={Classes.TotalActiveUsers}>
                      <Tooltip title={`${totalActiveUsers ?? 0} Active`}>
                        <FiberManualRecordIcon style={{color:'green'}}/>
                      </Tooltip>
                    </div>
                  }

                  <button
                    className={["btn btn-light", Classes.logoutButton].join(' ')}
                    type="button"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#ff6200",
                      color: "#fff",
                      border: "none"
                    }}
                    onClick={logout}
                  >
                    {loading ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      <div style={{ display: "flex" }}>
                        <Logout /> Logout
                      </div>
                    )}
                  </button>

                  {/* Notification Icon  */}
                  <div
                    onClick={handleNotification}
                    className={Classes.NotificationIcon}
                  >
                    <Badge badgeContent={unSeenNotificationsCount ?? 0} color="secondary" overlap="circular"  max={99}>
                      <NotificationsIcon
                        style={{ color: "#ff6200" }}
                        fontSize="large"
                      />
                    </Badge>
                  </div>
                </div>
              </div>
            </div>
            {error ? (
              <Alert
                variant="danger"
                onClose={() => setError(null)}
                dismissible
                style={{ position: "absolute", top: "90%", right: 20 }}
              >
                {error}
              </Alert>
            ) : null}
          </header>

          <div>
            <NotificationDialog
              open={open}
              handleClose={handleClose}
              setOpen={setOpen}
              notifications={notifications}
              fetchMoreData={fetchMoreData}
              maxPages={maxPages}
              page={page}
            />
          </div>

          {/* <LocationWatcher /> */}
        </>
      ) : null}
      <Routes>
        <Route
          path="/"
          element={
            isMaintenance ? (
              <MaintenancePage />
            ) : auth.authenticated ? (
              <Home
                isCreateOrderPage={isCreateOrderPage}
                setIsCreateOrderPage={setIsCreateOrderPage}
                collapseNavbar={collapseNavbar}
                isNavCollapse={isNavCollapse}
                navWidth={navWidth}
              />
            ) : (
              <Auth />
            )
          }
        >
          <Route path="dashboard">
            <Route index element={ <Analytics/> } />
            <Route path="reportAnalytics" element={ <ReportAnalytics/> } />
          </Route>
          <Route path='inventoryStockOut' element={<InventoryStockOut />}></Route>

          <Route path='docsList' element={<DocsListDashboard />}></Route>
          <Route path="users">
            <Route index element={<UsersNew />} />
            <Route path="new" element={<CreateNewUser />} />
            <Route path="roles" element={<Roles />} />
            <Route path=":id" element={<UserId />} />
          </Route>
          <Route path="customerAddresses" element={<Addresses />} />
          <Route path="deliveryBoy">
            <Route index element={<DeliveryBoyOrders />} />
            <Route path=":id" element={<DeliveryBoyOrderId />} />
          </Route>
          <Route path="draftOrdersNew">
            <Route index element={<DraftOrdersNew />} />
            <Route path=":id" element={<DraftOrderDetailPageNew />} />
          </Route>
          <Route path="ordersNew">
            <Route index element={<OrdersNew />} />
            <Route path="customers/:id" element={<OrdersNew />} />
            <Route path=":id" element={<OrderDetail />} />
            <Route path=":id/Allocate" element={<OrderAllocation />} />
            <Route path=":id/Un-Allocate" element={<OrderAllocation />} />
            <Route
              path=":id/Allocate-Un-Allocate"
              element={<OrderAllocation />}
            />
          </Route>
          <Route path="purchaseOrders">
            <Route index element={<PurchaseOrders />} />
            <Route path=":id" element={<PurchaseOrderDetail />} />
          </Route>
          <Route 
            path="editPurchaseOrder" 
            element={
              <PrivateRoutes 
                service={"editPurchaseOrders"} 
                permission={"read"}
              />
            }
          >
            <Route
              path=":Id"
              element={
                <EditPurchaseOrder
                  isCreateOrderPage={isCreateOrderPage}
                  setIsCreateOrderPage={setIsCreateOrderPage}
                />
              }
            />
          </Route>
          <Route path='inboundPurchaseOrders'>
            <Route index element={<InboundPurchaseOrders />} />
            <Route path=":id" element={<InboundPurchaseOrderDetail />} />
          </Route>
          <Route path="createOrder">
            <Route
              index
              element={
                <CreateOrder
                  isCreateOrderPage={isCreateOrderPage}
                  setIsCreateOrderPage={setIsCreateOrderPage}
                />
              }
            />
            <Route
              path=":Id"
              element={
                <CreateOrder
                  isCreateOrderPage={isCreateOrderPage}
                  setIsCreateOrderPage={setIsCreateOrderPage}
                />
              }
            />
          </Route>
          <Route path="createPurchaseOrder">
            <Route
              index
              element={
                <CreatePurchaseOrder
                  isCreateOrderPage={isCreateOrderPage}
                  setIsCreateOrderPage={setIsCreateOrderPage}
                />
              }
            />
            <Route
              path=":Id"
              element={
                <CreatePurchaseOrder
                  isCreateOrderPage={isCreateOrderPage}
                  setIsCreateOrderPage={setIsCreateOrderPage}
                />
              }
            />
          </Route>
          <Route path="draftPurchaseOrders">
            <Route index element={<DraftPurchaseOrders />} />
            <Route path=":id" element={<DraftPurchaseOrderDetail />} />
          </Route>
          <Route path="products">
            <Route index element={<Products />} />
            <Route path="addProduct" element={<AddProduct />} />
            <Route path=":Id" element={<ProductDetails />} />
          </Route>
          <Route path="productTransactions" element={<ProductTransactions/>}/>
          <Route path='inventoryManagement' element={<FranchiseInventoryManagement />} />
          <Route path='productManagement'>
            <Route index element={<FranchiseProductManagement />}/>
            <Route path=":Id" element={<UpdateProductManagement />} />
          </Route>
          <Route path='customers'>
            <Route index element={<Customers />} />
            <Route path=":customerId" element={<CustomerProfile />} />
            <Route path=":customerId/creditAgreement" element={<CreditAgreement />} />
            <Route
              path="fetchCustomerUpdateHistory"
              element={<CustomerUpdateHistory />}
            />
          </Route>
          <Route path="affiliates" element={<Affiliate />} />
          <Route path="commissions" element={<Commission />} />
          <Route path="ledgerDashboard" element={<LedgerDashboard />} />
          <Route path="createCommission" element={<CreateCommission />} />
          <Route path="commissions/:id" element={<UpdateCommission />} />
          <Route path="myTasks" element={<FieldSales />} />
          <Route path="myCustomers">
            <Route index element={<MyCustomers />} />
            <Route path=":Id" element={<CustomerDetails />} />
          </Route>
          <Route path="manager" element={<ManagerDashboard />} />
          <Route path="skuTransactions" element={<SkuTransactions />} />
          <Route path="dispatch">
            <Route index element={<Dispatch />} />
            {/* <Route path=":id" element={<OrderDetail />} /> */}
          </Route>
          <Route path="deliveryRiders">
            <Route index element={<DeliveryRiders />} />
            <Route path=":Id" element={<RiderDetails />} />
          </Route>
          <Route path="schemeDashboard">
            <Route index element={<SchemeDashboard />} />
          </Route>
          <Route path="schemes">
            <Route index element={<Schemes />} />
            {/* <Route path=":Id" element={<CreateOrder  isCreateOrderPage={isCreateOrderPage} setIsCreateOrderPage={setIsCreateOrderPage} />} /> */}
          </Route>
          <Route path="refundsNew">
            <Route index element={<RefundsNew />} />
            {/* <Route path=":id" element={<OrderDetail />} /> */}
          </Route>
          <Route path="returnsNew">
            <Route index element={<ReturnsNew />} />
            <Route path=":id" element={<ReturnDetail />} />
          </Route>
          <Route path="cancelsNew">
            <Route index element={<CancelsNew />} />
            {/* <Route path=":id" element={<OrderDetail />} /> */}
          </Route>
          <Route path="locations" element={<Locations />} />
          <Route path="orderAllocations" element={<OrderAllocated />} />
          <Route path="deliveryShipping">
            <Route index element={<DeliveryShipping />} />
            {deliveryShippingTabs?.map((tab, index) => (
              <Route path={tab} element={<DeliveryShipping type={tab} key={index} />} />
            ))}
          </Route>
          <Route path="inwardReturns">
            <Route index element={<ReturnInwards />} />
            {inwardTabs.map((tab) => (
              <Route path={tab} element={<ReturnInwards type={tab} />} />
            ))}
          </Route>
          <Route path="inwardPurchaseOrders">
            <Route index element={<PoInwards />} />
            {inwardTabs.map((tab) => (
              <Route path={tab} element={<PoInwards type={tab} />} />
            ))}
          </Route>
          <Route path="cancels" element={<Cancels />} />
          <Route path="profile" element={<Profile />} />
          <Route path="affiliates" element={<Affiliate />} />
          <Route path="fieldSales" element={<FieldSales />} />
          <Route path="franchise" element={<Franchises />} />
          <Route path="bins" element={<Bins />} />
          <Route path="updatePricing">
            <Route index element={<UpdatePricingProducts />} />
          </Route>
          <Route path="productsCreated">
            <Route index element={<ProductsCreated />} />
            <Route path=":Id" element={<ProductsCreatedDetails />} />
            {/* <Route path=':Id' element={<ProductDetail />} /> */}
          </Route>
          <Route path="reportServiceNew">
            <Route index element={<ReportServiceNew />} />
            <Route path=":Id" element={<ReportItems />} />
          </Route>
          <Route path="uploadImages">
            <Route index element={<UploadImages />} />
          </Route>
          <Route path="uploadImagesNew">
            <Route index element={<UploadImagesNew />} />
          </Route>
          {/* <Route path='inventory'>
            <Route index element={<Inventory />} />
          </Route> */}
          <Route path="skuToQrcodeBarcode" element={<SkuToQrCode />} />
          <Route path="createInterWHInventoryMoves">
            <Route
              path=":Id"
              element={
                <InterWarehouseInventoryMove
                  isCreateOrderPage={isCreateOrderPage}
                  setIsCreateOrderPage={setIsCreateOrderPage}
                />
              }
            />
            <Route
              index
              element={
                <InterWarehouseInventoryMove
                  isCreateOrderPage={isCreateOrderPage}
                  setIsCreateOrderPage={setIsCreateOrderPage}
                />
              }
            />
          </Route>
          <Route path="inventoryMove">
            <Route index element={<InventoryMove />} />
          </Route>
          <Route path="inventoryView">
            <Route index element={<InventoryView />} />
          </Route>
          <Route path="inventoryAdjustments">
            <Route index element={<InventoryAdjustments />} />
          </Route>
          <Route path="blog">
            <Route index element={<Blog />} />
            <Route path="createBlog" element={<CreateBlog />} />
            <Route path=":Id" element={<BlogDetail />} />
          </Route>
          <Route
            path="pushNotifications"
            element={<PushNotifications />}
          ></Route>
          <Route path="uploadOthersMaster">
            <Route index element={<UploadOthersMaster />} />
          </Route>
          <Route path="estimates">
            <Route index element={<Estimates />} />
            <Route path=":id" element={<EstimateId />} />
          </Route>
          <Route path="affiliateCommissions" element={<Commissions2 />} />
          <Route path="draftInterWarehouseInventoryMoves">
            <Route index element={<DraftInterWarehouseInventoryMoves />} />
            <Route path=":id" element={<DraftInterWHInventoryMoveDetails />} />
          </Route>
          <Route
            path="/interWarehouseInventoryMoves"
            element={<InterWarehouseInventoryMoves />}
          />
          <Route path="settings">
            <Route index element={<Settings />} />
            <Route path="discount" element={<Discount />} />
            <Route
              path="discount/createDiscount"
              element={<CreateDiscount />}
            />

            <Route path="notifications" element={<NotificationSettings />} />
            
            <Route path="pincode" element={<Pincodes />} />
            <Route path="states" element={<States />} />

            <Route path="catalogues">
              <Route index element={<Catalogues />} />
              <Route path=":id" element={<CatalogueDetails />} />
            </Route>

            <Route path="downloadedReports" element={<DownloadedReports />} />
            
            <Route path="company">
              <Route index element={<CompanyHome />} />
            </Route>

            <Route path="website">
              <Route index element={<WebsiteSettings />} />
              <Route path="productRange">
                <Route index element={<ProductRangeSettings />} />
              </Route>
              <Route path="stores">
                <Route index element={<Store />} />
                <Route path=":storeName" element={<ShowStoreLocationTable />} />
                <Route
                  path=":storeName/images"
                  element={<ShowStoreImages />}
                />
              </Route>
              <Route path="customer">
                <Route index element={<CustomerHome />} />
              </Route>
              <Route path="dynamicBanners">
                <Route index element={<DynamicBanners />} />
                <Route path="new" element={<CreateDynamicBanner />} />
                <Route path=":id" element={<DynamicBanner />} />
              </Route>
              <Route path="mainBanners">
                <Route index element={<MainBanners />} />
              </Route>
              <Route path="laminates">
              <Route index element={<Laminates />} />
              <Route path="new" element={<CreateLaminate />} />
                <Route path=":id" element={<Laminate />} />
            </Route>
           
            </Route>
           
            <Route
              path="paymentGatewayTransactions"
              element={<PaymentGatewayTransactions />}
            />
            <Route path="userActivities" element={<UserActivities />} />
            <Route path="users">
              <Route index element={<UsersNew />} />
              <Route path="new" element={<CreateNewUser />} />
              <Route path="roles" element={<Roles />} />
              <Route path=":id" element={<UserId />} />
            </Route>
          <Route
            path="notifications"
            element={<NotificationSettings />}
          />
          <Route
            path="myNotifications"
            element={<MyNotification />}
          />
          </Route>
          <Route
            path="/paymentGatewayTransactions"
            element={<PaymentGatewayTransactions />}
          />
          <Route
            path="/userActivities"
            element={<UserActivities />}
          />
          <Route
            path="/lowInventoryTracker"
            element={<LowInventoryTracker />}
          />
          <Route
            path="/inventoryAnalytics"
            element={<InventoryAnalytics />}
          />
          <Route
            path="/inventoriesWithPurchaseOrderDetails"
            element={<InventoriesWithPurchaseOrderDetails />}
          />
          <Route
            path="/inventoriesWithAllLocations"
            element={<InventoriesWithAllLocations />}
          />
        </Route>
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
